// pages/MathsPractice.tsx
import { Practice } from "@/components/Practice";
export function MathsPractice() {
  return <Practice endpoint="/api/mathematics/random" sessionType="maths" title="Maths Practice" />;
}